 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9781402793301_EPUB_CVI_R1 from '@/components/Text/9781402793301_epub_cvi_r1'
 import LOVE_1 from '@/components/love_1'
 import TEXT9781402793301_EPUB_TP_R1 from '@/components/Text/9781402793301_epub_tp_r1'
 import TEXT9781402793301_EPUB_COP_R1 from '@/components/Text/9781402793301_epub_cop_r1'
 import TEXT9781402793301_EPUB_TOC_R1 from '@/components/Text/9781402793301_epub_toc_r1'
 import TEXT9781402793301_EPUB_FRW_R1 from '@/components/Text/9781402793301_epub_frw_r1'
 import TEXT9781402793301_EPUB_ITR_R1 from '@/components/Text/9781402793301_epub_itr_r1'
 import TEXT9781402793301_EPUB_FM1_R1 from '@/components/Text/9781402793301_epub_fm1_r1'
 import TEXT9781402793301_EPUB_C01_R1 from '@/components/Text/9781402793301_epub_c01_r1'
 import TEXT9781402793301_EPUB_C02_R1 from '@/components/Text/9781402793301_epub_c02_r1'
 import TEXT9781402793301_EPUB_C03_R1 from '@/components/Text/9781402793301_epub_c03_r1'
 import TEXT9781402793301_EPUB_C04_R1 from '@/components/Text/9781402793301_epub_c04_r1'
 import TEXT9781402793301_EPUB_C05_R1 from '@/components/Text/9781402793301_epub_c05_r1'
 import TEXT9781402793301_EPUB_C06_R1 from '@/components/Text/9781402793301_epub_c06_r1'
 import TEXT9781402793301_EPUB_C07_R1 from '@/components/Text/9781402793301_epub_c07_r1'
 import TEXT9781402793301_EPUB_C08_R1 from '@/components/Text/9781402793301_epub_c08_r1'
 import TEXT9781402793301_EPUB_C09_R1 from '@/components/Text/9781402793301_epub_c09_r1'
 import TEXT9781402793301_EPUB_C10_R1 from '@/components/Text/9781402793301_epub_c10_r1'
 import LOVE_2 from '@/components/love_2'
 import TEXT9781402793301_EPUB_BM3_R1 from '@/components/Text/9781402793301_epub_bm3_r1'
 import TEXT9781402793301_EPUB_BM1_R1 from '@/components/Text/9781402793301_epub_bm1_r1'
 import TEXT9781402793301_EPUB_BM2_R1 from '@/components/Text/9781402793301_epub_bm2_r1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/9781402793301_epub_toc_r1",
 			"name" : "Text/9781402793301_epub_toc_r1",
 			"component" : TEXT9781402793301_EPUB_TOC_R1
 		},
 		{
 			"path" : "/Text/9781402793301_epub_frw_r1",
 			"name" : "Text/9781402793301_epub_frw_r1",
 			"component" : TEXT9781402793301_EPUB_FRW_R1
 		},
 		{
 			"path" : "/Text/9781402793301_epub_itr_r1",
 			"name" : "Text/9781402793301_epub_itr_r1",
 			"component" : TEXT9781402793301_EPUB_ITR_R1
 		},
 		{
 			"path" : "/Text/9781402793301_epub_fm1_r1",
 			"name" : "Text/9781402793301_epub_fm1_r1",
 			"component" : TEXT9781402793301_EPUB_FM1_R1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js